<template>

    <v-autocomplete
        ref="input"
        :key="reload"
        :item-value="keyValue"
        :item-text="keyName"
        :value="value"
        :items="items"
        :label="label"
        @input="onInput"
        @change="onChange"
        @click="onClick"
        @click:clear="onClear"
        :clearable="enableClearable"
        :autofocus="enableAutofocus"
        :loading="loading"
        :disabled="disabled"
        :error-messages="errors"
        :search-input.sync="search"
        :multiple="multiple"
        :chips="enableChips"
        :return-object="returnObject"
        id="test"
    >
        <v-list-item
            v-if="enableShowMore"
            slot="prepend-item"
            class="grey--text"
            @click="showMore"
        >
            {{ $t('fields.show_more') }}
        </v-list-item>
    </v-autocomplete>

</template>

<script>
  export default {
    name: 'AutoComplete',
    props: {
        /*
        value: {
          type: [String, Array, Number],
          default() { return null; },
        },
        */
        reload: [String, Number],
        keyValue: [String, Number],
        keyName: [String, Number],
        value: [String, Number, Array, Object],
        items: Array,
        label: String,
        delay: {
            type: Number,
            default: 0,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        enableChips: {
            type: Boolean,
            default: false,
        },
        enableClearable: {
            type: Boolean,
            default: false,
        },
        enableAutofocus: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        enableShowMore: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showMoreLabel: {
            type: String,
            default: 'Show more',
        },
        errors: {
            type: [String, Array],
            default: '',
        },
    },
    data() {
      return {
        timeout: null,
        search: null,
      };
    },
    methods: {
      focus() {
        if (this.$refs.input && this.$refs.input.focus) {
          this.$refs.input.focus();
        }
      },
      onInput(value) {
        this.$emit('input', value);
      },
      onChange(value) {
        this.$emit('change', value);
      },
      onClick(value) {
        this.$emit('click', value);
      },
      onClear(value) {
        this.$emit('clear', value);
      },
      showMore() {
        this.$emit('showMore');
      },
      emitDebounceEvent(name, value) {
        if (this.delay) {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.timeout = window.setTimeout(() => {
            this.$emit(name, value);
            }, this.delay);
        } else {
            this.$emit(name, value);
        }
      },

    },
    watch: {
      search(value) {
        this.emitDebounceEvent('search', value);
      },
    },
  };
</script>

<style scoped>

</style>
